import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Container, Button, Label } from 'reactstrap';
import {
  AppAside,
  AppBreadcrumb,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppSidebarNav,
} from '@coreui/react';

import Language from '../../components/Language/Language';

// sidebar nav config
import BCMDashboard from '../Navigation/BCMDashboard';
import SystemAdmin from '../Navigation/SystemAdmin';
import BCMAdmin from '../Navigation/BCMAdmin';
import BCMReport from '../Navigation/BCMReport';
import BCMUser from '../Navigation/BCMUser';
import BCMFAQ from '../Navigation/BCMFAQ'

// routes config
import routes from '../../routes';
import DefaultAside from './DefaultAside';
import DefaultFooter from './DefaultFooter';
import DefaultHeader from './DefaultHeader';
import DefaultTab from './DefaultTab';
import AxiosInstance from '../../components/AxiosInstance/AxiosInstance';

var items = {
  items:
    [{
      screenCode: '',
      name: 'Dashboard',
      url: '/dashboard',
      //icon: 'icon-speedometer',
      //badge: {
      //  variant: 'info',
      //  text: 'NEW',
      //},
    }]
};

class DefaultLayout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      routeLink: routes,
      routeLink: routes,
      navigation: BCMDashboard,
      new_navData: items,
    };

    this.subMenuFilter = this.subMenuFilter.bind(this);
    this.scoreCardModal = this.scoreCardModal.bind(this);
    this.func_showScoreCard = this.func_showScoreCard.bind(this);
    this.MultiscoreCardModal = this.MultiscoreCardModal.bind(this); 
  }

  componentDidMount() {
    this.getNavigationValue();
  }

  getNavigationValue() {

    var value = "BCM Dashboard";

    if (sessionStorage.getItem("sub_Menu") === null) {
      sessionStorage.setItem("sub_Menu", value);
    } else {
      value = sessionStorage.getItem("sub_Menu")
    }

    this.storeNavData(value);
  }

  storeNavData(data) {
    // add to get navigation folder
    // eslint-disable-next-line default-case
    switch (data) {
      case "BCM Dashboard":
        this.setState({
          navigation: BCMDashboard
        });
        break
      case "System Admin":
        this.setState({
          navigation: SystemAdmin
        });
        break
      case "BCM Admin":
        this.setState({
          navigation: BCMAdmin
        });
        break
      case "BCM Report":
        this.setState({
          navigation: BCMReport
        });
        break
      case "BCM User":
        this.setState({
          navigation: BCMUser
        });
		break
	  case "BCM FAQ":
        this.setState({
          navigation: BCMFAQ
        });
    }

    this.loadSidebar();
  }

  //filter for the sidemenu base on different module . Refer to navigation folder 
  subMenuFilter(sub_Menu) {

    sessionStorage.setItem("sub_Menu", sub_Menu);

    // eslint-disable-next-line default-case
    switch (sub_Menu) {
      case "BCM Dashboard":
        this.storeNavData("BCM Dashboard")
        break
      case "System Admin":
        this.storeNavData("System Admin")
        break
      case "BCM Admin":
        this.storeNavData("BCM Admin")
        break
      case "BCM Report":
        this.storeNavData("BCM Report")
        break
      case "BCM User":
        this.storeNavData("BCM User")
        break
	  case "BCM FAQ":
        this.storeNavData("BCM FAQ")
    }
  }

  loadSidebar() {
    // Access Rgiths Checking
    AxiosInstance({
      method: 'Post',
      url: '/tbSYS_b_ScreenAccess/usp_tbSYS_b_ScreenAccess_SelectAllWtbSYSmUserIDLogic',
      errorHandle: true
    })
      .then(response => {

        var screenAccessData = response.data["ouT_usp_tbSYS_b_ScreenAccess_SelectAllWtbSYSmUserIDLogicList"].map(p => p.screenCode);
        var module_LicenseData = response.data["module_License"];

        var navigation = this.state.navigation.items;
        var new_navData_items = [];
        var routeLink = [];

        //if (sessionStorage.getItem('sub_Menu') == "BCM User" && sessionStorage.getItem('NewQRadar_tbBCMmDepartmentID') == null) {
        //  new_navData_items = navigation.filter((el) => (el.name == "Scorecard Master Selection" || el.name == "Scorecard Selection") && (data.includes(el.screenCode) || el.screenCode == ""));

        //  routeLink = this.state.routeLink.filter((el) => (el.url != "/bcmuser/departmentinfo/departmentinfolist" ||
        //    el.url != "/bcmuser/mbco" ||
        //    el.url != "/bcmuser/businessimpactanalysis/CBFList" ||
        //    el.url != "/bcmuser/itapplicationlisting" ||
        //    el.url != "/bcmuser/internaldependencies/internaldependencieslist" ||
        //    el.url != "/bcmuser/externaldependencies/externaldependencieslist" ||
        //    el.url != "/bcmuser/cbf-vital-record" ||
        //    el.url != "/bcmuser/manual-workaround-list" ||
        //    el.url != "/bcmuser/emergencyresponse" ||
        //    el.url != "/bcmuser/emergencycommandcenter" ||
        //    el.url != "/bcmuser/crisis-management-team" ||
        //    el.url != "/bcmuser/roles-and-responsibilities" ||
        //    el.url != "/bcmuser/riskscenario/riskscenariolist" ||
        //    el.url != "/bcmuser/resourcerequirement/resourcerequirementlist" ||
        //    el.url != "/bcmuser/return-to-normal-operation" ||
        //    el.url != "/bcmuser/reference-records" ||
        //    el.url != "/bcmuser/bcmauditlog" ||
        //    el.url != "/bcmuser/historylist" ||
        //    el.url != "/bcmuser/submitforapproval") && (data.includes(el.screenCode) || el.screenCode == ""));
        //} else {
        //  new_navData_items = navigation.filter((el) => data.includes(el.screenCode) || el.screenCode == "").filter(function (Obj, key) {
        //    var navigation_Obj = Obj;
        //    if (navigation_Obj.hasOwnProperty("children")) {
        //      navigation_Obj.children = navigation_Obj.children.filter((el) => data.includes(el.screenCode) || el.screenCode == "").filter(function (Obj, key) {
        //        var children_Obj = Obj;
        //        if (children_Obj.hasOwnProperty("children")) {
        //          children_Obj.children = children_Obj.children.filter((el) => data.includes(el.screenCode) || el.screenCode == "");

        //          if (children_Obj.children.length > 0) {
        //            return children_Obj;
        //          } else {
        //            return null;
        //          }
        //        }
        //        else {
        //          return children_Obj;
        //        }
        //      });

        //      if (navigation_Obj.children.length > 0) {
        //        return navigation_Obj;
        //      } else {
        //        return null;
        //      }
        //    }
        //    else {
        //      return navigation_Obj;
        //    }
        //  });

        //  routeLink = this.state.routeLink.filter((el) => data.includes(el.screenCode) || el.screenCode == "");
        //}
        
        new_navData_items = navigation.filter((el) => (screenAccessData.includes(el.screenCode) || el.screenCode == "") && (module_LicenseData.includes(el.moduleCode) || el.moduleCode == "")).filter(function (Obj, key) {
          var navigation_Obj = Obj;
          if (navigation_Obj.hasOwnProperty("children")) {
            navigation_Obj.children = navigation_Obj.children.filter((el) => (screenAccessData.includes(el.screenCode) || el.screenCode == "") && (module_LicenseData.includes(el.moduleCode) || el.moduleCode == "")).filter(function (Obj, key) {
              var children_Obj = Obj;
              if (children_Obj.hasOwnProperty("children")) {
                children_Obj.children = children_Obj.children.filter((el) => (screenAccessData.includes(el.screenCode) || el.screenCode == "") && (module_LicenseData.includes(el.moduleCode) || el.moduleCode == ""));

                if (children_Obj.children.length > 0) {
                  return children_Obj;
                } else {
                  return null;
                }
              }
              else {
                return children_Obj;
              }
            });

            if (navigation_Obj.children.length > 0) {
              return navigation_Obj;
            } else {
              return null;
            }
          }
          else {
            return navigation_Obj;
          }
        });

        routeLink = this.state.routeLink.filter((el) => (screenAccessData.includes(el.screenCode) || el.screenCode == "") && (module_LicenseData.includes(el.moduleCode) || el.moduleCode == ""));

        var new_navData = {
          items: new_navData_items
        };

        this.setState({
          new_navData: new_navData,
          routeLink: routeLink
        });
      })
      .catch(function (error) {
      });
  }

  scoreCardModal() {
    let url = this.props.location.pathname
    return window.location.hash = "/bcmuser/scorecard-selection?url=" + url
  }

  MultiscoreCardModal() {
    let url = this.props.location.pathname
    return window.location.hash = '/bcmuser/scorecard-selection?url=' + url + '&multiselect=true';
  }

  func_showScoreCard() {

    var archive = "";

    if (sessionStorage.getItem("NewQRadar_tbWFLtBCMTransactionID") > 0) {
      archive = <Label style={{ fontWeight: "bold", marginLeft: "18px" }}>{Language.GetLanguageByID(5025.01)}</Label>;
    }

    if (sessionStorage.getItem('redirect_to_bcmuser') == "true") {
      this.subMenuFilter("BCM User");
      sessionStorage.removeItem("redirect_to_bcmuser");
    }

    if (sessionStorage.getItem('sub_Menu') == "BCM User") {
      return (
        <div className="scorecard-btnArea">
          <Button className="pull-right" color="scorecard" onClick={this.scoreCardModal} ignoreaccesscontrol="true">{Language.GetLanguageByID(9529.01)} [{sessionStorage.getItem("NewQRadar_scoreCard")}]</Button>
          {
            archive
          }
        </div>
      );
    }
    //else if (sessionStorage.getItem('sub_Menu') == "BCM Dashboard") {
    //  return (
    //    <div className="scorecard-btnArea">
    //      <Button className="pull-right" color="scorecard" onClick={this.MultiscoreCardModal} ignoreaccesscontrol="true">{Language.GetLanguageByID(1848.01)} [{sessionStorage.getItem("NewQRadar_Dashboard_SelectedDepartmentID") != null ? Language.GetLanguageByID(2228.01) : ''}]</Button>
    //    </div>
    //  );
    //}
    else {
      return null
    }
  }

  render() {

    return (

      <div className="app">
        <AppHeader fixed >
          <DefaultHeader action={this.subMenuFilter} />
        </AppHeader>
        <div className="app-body">
          <AppSidebar fixed display="lg">
            <AppSidebarHeader />
            <AppSidebarForm />
            <AppSidebarNav navConfig={this.state.new_navData} {...this.props} />
            <AppSidebarFooter />
            <AppSidebarMinimizer />
          </AppSidebar>
          <main className="main">
            <Container fluid style={{ padding: "unset" }} className="d-lg-none d-xl-none"  >
              <DefaultTab action={this.subMenuFilter} />
            </Container>

            <AppBreadcrumb appRoutes={this.state.routeLink} className="d-md-down-none" />
            {
              this.func_showScoreCard()
            }
            <Container fluid>
              <Switch>
                {
                  this.state.routeLink.map((route, idx) => {
                    return route.component ? (<Route key={idx} path={route.path} exact={route.exact} name={route.name} render={props => (
                      <route.component {...props} />
                    )} />)
                      : (null);
                  },
                  )
                }

                <Redirect from='/' to="/dashboard" />
              </Switch>
            </Container>
          </main>
          <AppAside fixed>
            <DefaultAside />
          </AppAside>
        </div>
        <AppFooter>
          <DefaultFooter />
        </AppFooter>
      </div>
    );
  }
}
export default DefaultLayout;
